import "./NavbarStyles.css";
import { MenuItems } from "./MenuItems";
import AuthModal from "./AuthModal";

import React from "react";
import { useState } from "react";

const Navbar = () => {
  const [clicked, setClicked] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authInitialTab, setAuthInitialTab] = useState("login");

  const clickHandler = () => {
    setClicked(!clicked);
  };

  const handleSignupClick = () => {
    setAuthInitialTab("signup");
    setAuthModalOpen(true);
    setClicked(false);
  };

  return (
    <nav className="NavbarItems">
      <h1 className="Navbar-logo">Trippy</h1>
      <div className="menu-icons" onClick={clickHandler}>
        <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
      </div>
      <ul className={clicked ? "nav-menu active" : "nav-menu"}>
        {MenuItems.map((item, index) => {
          // Render the mobile-only Sign up menu item as a button
          if (item.cName === "nav-links-mobile" || /sign ?up/i.test(item.title)) {
            return (
              <li key={index}>
                <button
                  className={item.cName}
                  onClick={() => {
                    handleSignupClick();
                  }}
                >
                  {item.title}
                </button>
              </li>
            );
          }

          return (
            <li key={index}>
              <a className={item.cName} href={item.url}>
                <i className={item.icon}></i>
                {item.title}
              </a>
            </li>
          );
        })}
        <button onClick={handleSignupClick}>Signup</button>
      </ul>
      <AuthModal isOpen={authModalOpen} initialTab={authInitialTab} onClose={() => setAuthModalOpen(false)} />
    </nav>
  );
};

export default Navbar;

// import React, { Component } from 'react'

// class Navbar extends Component {
//     constructor(props) {
//       super(props)

//       this.state = {
//          clicked :false
//       }
//     }

//     clickHandler =()=>{
//         this.setState({
//             clicked: !this.state.clicked
//         })
//     }

//   render() {
//     return (
//       <nav className="NavbarItems">
//         <h1 className="Navbar-logo">Trippy</h1>
//         <div className="menu-icons" onClick={this.clickHandler}>
//             <i className={this.state.clicked ? "fas fa-times" :  "fas fa-bars"}></i>

//         </div>
//         <ul className={this.state.clicked ? "nav-menu active": "nav-menu"} >
//             {MenuItems.map((item, index) => {
//                 return (
//                 <li key={index} >
//                 <a className={item.cName} href= {item.url} >
//                 <i className={item.icon} ></i>
//                 {item.title}</a>
//             </li>
//                 )
//             })}
//             <button >Signup</button>
//         </ul>
//       </nav>
//     )

//   }
// }

// export default Navbar
